import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
	selector: 'fb-fabric-flow-stats',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './fabric-flow-stats.component.html',
	styleUrls: ['./fabric-flow-stats.component.scss']
})
export class FabricFlowStatsComponent implements OnInit {

	ngOnInit() {
	}

}
